import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface MediaInfoBoxProps {
  children: React.ReactNode;
}

export function MediaInfoBox({ children }: MediaInfoBoxProps) {
  return (
    <Box
      sx={{
        flex: 1,
        bgcolor: 'grey.50',
        borderRadius: 3,
        p: 2,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
      }}
    >
      <InfoOutlinedIcon sx={{ color: 'info.main', fontSize: 20, mt: 0.25 }} />
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    </Box>
  );
}
